"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValuationDisplayStepDefinition = void 0;
const TemplateTypes_1 = require("../../../../Enum/TemplateTypes");
const InchcapeViewEvents_1 = require("../../Enum/InchcapeViewEvents");
const StepTypes_1 = require("../../../../Enum/StepTypes");
const WidgetStepPlugin_1 = require("auto-widget-framework/src/Plugin/WidgetStep/WidgetStepPlugin");
const WidgetStepPluginDefinition_1 = require("auto-widget-framework/src/Plugin/WidgetStep/WidgetStepPluginDefinition");
const QuestionnaireTypes_1 = require("../../../../Enum/QuestionnaireTypes");
const RepositoryTypes_1 = require("../../../../Enum/RepositoryTypes");
const Collection_1 = require("../../../../Model/Collection");
class ValuationDisplayStep extends WidgetStepPlugin_1.default {
    constructor(definition, widgetConfig, state, eventContext, ractiveWrapper, repoFactory, priceExtractor, dateFormatter) {
        super(definition, widgetConfig, state, eventContext, ractiveWrapper);
        this.questionnairesToLoad = [
            QuestionnaireTypes_1.QuestionnaireTypes.CONDITION,
            QuestionnaireTypes_1.QuestionnaireTypes.DETAILS,
            QuestionnaireTypes_1.QuestionnaireTypes.HISTORY,
            QuestionnaireTypes_1.QuestionnaireTypes.FINANCE,
            QuestionnaireTypes_1.QuestionnaireTypes.NEXT_ACTIONS,
            QuestionnaireTypes_1.QuestionnaireTypes.FACTORY_FITTED_OPTIONS,
            QuestionnaireTypes_1.QuestionnaireTypes.OPTIONAL_EXTRAS,
        ];
        this.priceExtractor = priceExtractor;
        this.questionnaireRepo = repoFactory.create(RepositoryTypes_1.RepositoryTypes.QUESTIONNAIRE, { config: this.widgetConfig });
        this.dateFormatter = dateFormatter;
    }
    /**
     * @inheritDoc
     * @see IContainerInjection
     */
    static create(definition, widgetConfig, state, eventContext, container) {
        return new this(definition, widgetConfig, state, eventContext, container.get("ractive_wrapper"), container.get("factory.repository"), container.get("valuation.price_extractor"), container.get("formatter.date"));
    }
    /**
     * @inheritDoc
     */
    getTemplate() {
        return this.widgetConfig.getTemplate(TemplateTypes_1.TemplateTypes.VALUATION_VIEW).getTemplate();
    }
    /**
     * @inheritDoc
     */
    initialize() {
        return Promise.resolve().then(() => {
            const valuation = this.state.getValuation();
            this.eventContext.emit(InchcapeViewEvents_1.InchcapeViewEvents.VALUATION_LOADED, valuation);
            this.state.setVehicle(valuation.getVehicle());
            this.state.setValuationPrice(this.priceExtractor.getActualPrice(valuation));
            return this.loadQuestionnaires(valuation)
                .then(this.processQuestionnaires.bind(this));
        });
    }
    processQuestionnaires(questionnaireDataSets) {
        questionnaireDataSets.forEach(([answers, questionnaire]) => {
            if (!answers) {
                return;
            }
            questionnaire.getQuestions().forEach((question) => {
                if (!question.isValueTypeDate()) {
                    return;
                }
                if (answers && answers.getAnsweredQuestion(question.getId())) {
                    const value = answers.getAnsweredQuestion(question.getId())
                        .getValue();
                    if (value) {
                        answers.getAnsweredQuestion(question.getId())
                            .setValue(this.dateFormatter.format(value, this.widgetConfig.getDateFormat()));
                    }
                }
            });
            const mergedQuestionnaires = [QuestionnaireTypes_1.QuestionnaireTypes.FINANCE, QuestionnaireTypes_1.QuestionnaireTypes.HISTORY, QuestionnaireTypes_1.QuestionnaireTypes.DETAILS];
            if (mergedQuestionnaires.includes(questionnaire.getMachineName())) {
                this.mergeQuestionnaires(questionnaireDataSets, [answers, questionnaire]);
            }
        });
    }
    /**
     *  Merge FINANCE, HISTORY, DETAILS into CONDITION questionnaire since they need to be displayed together
     */
    mergeQuestionnaires(questionnaireDataSets, currentSet) {
        let conditionQuestionnaire = questionnaireDataSets.find(([_, questionnaire]) => questionnaire.getMachineName() === QuestionnaireTypes_1.QuestionnaireTypes.CONDITION);
        let mergedAnswers = new Collection_1.default([
            ...conditionQuestionnaire[0].getAnsweredQuestions().getArray(),
            ...currentSet[0].getAnsweredQuestions().getArray()
        ]);
        conditionQuestionnaire[0].setAnsweredQuestions(mergedAnswers);
        let mergedQuestions = new Collection_1.default([
            ...conditionQuestionnaire[1].getQuestions().getArray(),
            ...currentSet[1].getQuestions().getArray()
        ]);
        conditionQuestionnaire[1].setQuestions(mergedQuestions);
    }
    /**
     * Loads in state all the answered questionnaires and the respective questionnaire.
     *
     * @param valuation
     */
    loadQuestionnaires(valuation) {
        const answeredQuestionnaires = valuation.getAnsweredQuestionnaires();
        const promises = this.questionnairesToLoad.map((type) => {
            const answered = answeredQuestionnaires.find((q) => q.getId() === type);
            if (!answered) {
                return Promise.resolve([]);
            }
            return this.questionnaireRepo.get(type)
                .then(([questionnaire]) => {
                this.state.setAnsweredQuestionnaire(questionnaire, answered);
                return [answered, questionnaire];
            });
        });
        return Promise.all(promises);
    }
}
exports.default = ValuationDisplayStep;
exports.ValuationDisplayStepDefinition = new WidgetStepPluginDefinition_1.default({
    id: StepTypes_1.StepTypes.VALUATION_VIEW,
    class: ValuationDisplayStep,
});
